import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import Manage from './manage'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Teams)',
  collection: {
    endpoint: `/api/admin/platform/apps/${props.app.code}/teams`,
    table: [
      { label: 't(ID)', key: 'team.id', sort: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'team.title', sort: 'title', primary: true, format: ({ team }) => <TeamToken { ...team } /> }
    ],
    defaultSort: { key: 'title', order: 'asc' },
    empty: {
      icon: 'building-o',
      title: 't(No Teams)',
      text: 't(You have not yet assigned this app to any teams)',
      buttons: [
        { label: 'Manage Teams', modal: <Manage app={ props.app } /> }
      ]
    },
    entity: 'team'
  },
  tasks: {
    items: [
      { label: 'Manage Teams', modal: <Manage app={ props.app } /> }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
